module.exports = __webpack_public_path__ + "img/index6.20ca346d.png";